import {CommonUrlService} from 'core/base/CommonUrlService';
import {TAppInitialController} from 'core/redux/types';
import {getCategoryNodeHelper} from 'modules/categories/helpers';
import {getProductGroupsList, getProductList} from 'modules/products/thunks';
import {ProductGroupEnum} from 'new-models';
import {FilterUrlService} from 'plugins/modules/filter/services/FilterUrlService';

export const productControllerByCategory: TAppInitialController<void> = async (store, ctx) => {
    const {dispatch} = store;

    const categoryNode = await getCategoryNodeHelper(store, ctx);

    if (!categoryNode) {
        return;
    }

    const commonUrlService = new CommonUrlService(
        new URLSearchParams(),
        async (urlSearchParams) => {
            // TODO:  до решения проблемы с сетингом actionId
            urlSearchParams.delete('filter[actionId]');
            await dispatch(getProductList(urlSearchParams, categoryNode.id));
        },
        {
            query: ctx.query,
        }
    );

    await commonUrlService.hydrate();
};

export const viewedProductListController: TAppInitialController<void> = async ({dispatch}) => {
    await dispatch(getProductGroupsList(ProductGroupEnum.Viewed));
};

export const productControllerBySelection: TAppInitialController<void> = async (store, ctx) => {
    const {dispatch} = store;
    const selection = ctx.query.path;

    const commonUrlService = new CommonUrlService(
        new URLSearchParams(`filter[nameplates]=${selection}`),
        async (urlSearchParams) => {
            // TODO:  до решения проблемы с сетингом actionId
            urlSearchParams.delete('filter[actionId]');
            await dispatch(getProductList(urlSearchParams));
        },
        {
            query: ctx.query,
        }
    );

    await commonUrlService.hydrate();
};

export const productControllerByCollectionCode: TAppInitialController<void> = async (store, ctx) => {
    const {dispatch} = store;
    const collectionCode = ctx.query.path;

    FilterUrlService.resetStaticFilter();

    const commonUrlService = new CommonUrlService(
        new URLSearchParams(`filter[collectionCode]=${collectionCode}`),
        async (urlSearchParams) => {
            // TODO:  до решения проблемы с сетингом actionId
            urlSearchParams.delete('filter[actionId]');
            await dispatch(getProductList(urlSearchParams));
        },
        {
            query: ctx.query,
        }
    );

    await commonUrlService.hydrate();
};
